<template>
  <div class="index">
    <div class="content">
      <div class="main">
        <h3>最新</h3>
        <template v-for="(item, index) in list">
          <div class="list" :key="index">
            <div class="list-img">
              <img v-if="item.a_img" :src="situationImgUrl + item.a_img" alt="">
            </div>
            <div class="text">
              <h4>
                <span @click="handleDetail(item, index)">{{item.title}}</span>
              </h4>
              <p>{{item.essay}}</p>
              <div>
                <p>
                  <img src="../assets/time1.png" alt="">
                  <span>{{item.a_time}}</span>
                </p>
                <p>
                  <!-- <img src="../assets/msg.png" alt="">
                  <span>123</span> -->
                  <img src="../assets/browse.png" alt="">
                  <span>{{item.amount}}</span>
                  <!-- <img src="../assets/zan0.png" alt="">
                  <span>123</span> -->
                </p>
              </div>
            </div>
          </div>
        </template>
        <div style="text-align: center;">
          <span v-if="list.length < 1" style="padding: 200px 0; display: inline-block; font-size: 50px;">暂无数据···</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'index',
    metaInfo () {
      return {
        title:'魏二飞的博客'
      }
    },
    data () {
      return {
        list: []
      }
    },

    mounted () {
      this.$http.get('article/get_article_list', {type: 0}, true).then(res => {
        if(res.data.code == 0){
          this.list = res.data.data.products
        } else {
          this.$message.warning(res.data.msg)
        }
      }).catch(err => {
        this.$message.error('网络有误！')
      })
    },

    methods: {
      handleDetail (item, index) {
        this.$router.push({
          path: `/detail/${item.id}/index`,
        })
      },
    }
  }
</script>

<style>
  .content .main {
    margin-bottom: 30px;
  }

  .content .main h3 {
    padding: 20px 0 10px 0;
    border-bottom: 5px dashed #db6d4c;
    color: #000000;
  }

  .main .list {
    height: 100%;
    padding: 30px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #666;
    border-left: 5px solid transparent;
    display: flex;
    justify-content: space-between;
    /* align-items: center; */
  }

  .main .list:hover {
    background-color: #c5baa1;
    border-left: 5px solid #ca9911;
  }

  .main .list .list-img {
    width: 20%;
    height: 150px;
  }

  .main .list .list-img img {
    width: 100%;
    height: 100%;
    object-fit: none;
  }

  .main .list .text {
    width: 78%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 0;
    line-height: 30px;
  }

  .main .list .text h4 {
    color: #000000;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  .main .list .text h4 span:hover {
    color: #1ba9cc;
    text-decoration: underline;
    cursor: pointer;
  }

  .main .list .text>p {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 14px;
  }

  .main .list .text>div {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
  }

  .main .list .text>div>p {
    display: flex;
    align-items: center;
  }

  .main .list .text>div img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue